var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.comments.length > 0)?_c('span',[_c('card',{staticStyle:{"background-color":"#eeeeff"},attrs:{"shadow":""}},[_c('strong',[_vm._v(_vm._s(_vm.$t('comments'))+":")]),_c('ul',_vm._l((_vm.comments),function(aComment){return _c('li',{key:aComment.id},[_vm._v("\n      "+_vm._s(aComment.comment)+"\n      ")])}),0)]),_c('br')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }